export const defaultCacheTime = 1000 * 60 * 5; // 5min
export const defaultStaleTime = 1000 * 60 * 5; // 5min
export default {};
